var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[_vm._t("default"),(_vm.isLoading)?_c('logo-loader'):_c('div',{staticClass:"ages-container"},[_c('highcharts',{attrs:{"options":_vm.options}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }